import { render, staticRenderFns } from "./ThemeThumbnail.vue?vue&type=template&id=2a8e3f6b&scoped=true"
import script from "./ThemeThumbnail.vue?vue&type=script&lang=js"
export * from "./ThemeThumbnail.vue?vue&type=script&lang=js"
import style0 from "./ThemeThumbnail.vue?vue&type=style&index=0&id=2a8e3f6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8e3f6b",
  null
  
)

export default component.exports